import { render, staticRenderFns } from "./Carteralaboratorio.vue?vue&type=template&id=d94eab6e"
import script from "./Carteralaboratorio.vue?vue&type=script&lang=js"
export * from "./Carteralaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports